<template>
  <!-- Position defined in parent component -->
  <div class="blur-overlay flex items-center justify-center text-center px-16">
    <div class="flex flex-col items-center justify-center" :class="{ 'backdrop': useBackdrop }"
    :style="{ marginBottom: `${verticalOffset}px` }">
      <div class="flex items-center justify-center rounded-full bg-neutral-25"
      :class="useBackdrop ? 'w-11 h-11' : 'w-7 h-7'">
        <LockedIcon class="text-icon-normal" />
      </div>
      <BaseText type="label" size="sm" class="text-text-muted mt-5">
        {{ title }}
      </BaseText>
      <BaseText type="body" size="sm" class="text-text-normal mt-1.5">
        {{ description }}
      </BaseText>
      <BasePrimaryButton 
        class="pointer-events-auto mt-5"
        text="Start Tracking"
        :icon="optionalIcon"
        @click="trackBrand"
      />
    </div>
  </div>
</template>

<script>
import EventBus from '@/plugins/BaseNotifications/EventBus'
import LockedIcon from '@/components/globals/Icons/LockedIconV2.vue'
import SpyderIcon from '@/components/globals/Icons/SidebarIcons/SpyderIcon.vue'

export default {
  name: 'PreviewLockedOverlay',
  components: {
    LockedIcon,
    SpyderIcon
  },
  props: {
    title: {
      type: String,
      default: 'Preview Locked'
    },
    description: {
      type: String,
      default: 'This preview is locked. Please upgrade to view the full data.'
    },
    useBackdrop: {
      type: Boolean,
      default: false
    },
    showButtonIcon: {
      type: Boolean,
      default: false
    },
    verticalOffset: {
      type: Number,
      default: 0
    }
  },
  computed: {
    optionalIcon () {
      return this.showButtonIcon ? SpyderIcon : null
    }
  },
  methods: {
    trackBrand () {
      EventBus.$emit('spyder:track-brand')
    }
  }
}
</script>

<style scoped>
.blur-overlay {
  background-color: rgba(255, 255, 255, 0.24);
  backdrop-filter: blur(10px);
}
.backdrop {
  background-color: white;
  padding: 24px;
  border-radius: 16px;
  border: 1px solid #EAEFF3;
}
</style>